<script setup lang="ts">
/**
 * Intro Loader
 * -------------------------------------
 *
 */
</script>

<template>
    <div
        data-t-loading-overlay
        class="
            fixed
            inset-0
            z-50
            bg-background-1/90
        "
    >
        <LoadingSpinner
            data-spinner
            class="
                absolute
                top-1/2
                left-1/2
                size-14!
                -translate-1/2
            "
        />
    </div>
</template>
